export const StatusDict = {
    Active: {
        text: '运行中',
        type: 'success',
    },
    Terminating: {
        text: '生效中',
        type: 'warning',
    },
};
// @todo 这名字并不对
export type SidercarStatus = keyof typeof StatusDict;
